import { BaseRESTService } from '../../../common/services/BaseRESTService';

type SensorConfig = {
  version: string;
  url: string;
};

export type SensorsConfig = {
  ANALYSIS: {
    JAVA_SCANNER: SensorConfig | null;
    NETWORK_ANALYZER: SensorConfig | null;
  };
  APP: {
    JAVA: SensorConfig | null;
  };
  FILESYSTEM: {
    LINUX: SensorConfig | null;
    WINDOWS: SensorConfig | null;
  };
};

export class OrganizationSensorsRepository extends BaseRESTService {
  async getSensors(): Promise<SensorsConfig> {
    const response = await this.get('/api/internal/tools');
    return <SensorsConfig>response.data;
  }

  async sensorPathExists(path: string): Promise<boolean> {
    const { status } = await this.head(path);
    return status === 200;
  }
}
